import React from "react";
import {Team} from "../../../../../generated/graphql";

interface Props {
  team: Team;
}

export function EditTeamRegion({ team }: Props) {
  return (
    <div className="flex bg-secondary py-2 px-4 items-center rounded">
      <div className="flex-grow">
        <div className="leading-none text-sm color-white-40 mb-1">
          SERVER REGION
        </div>
        <div className="leading-none color-white-60">{team.region}</div>
      </div>
    </div>
  );
}
